/* eslint-disable no-unused-vars */
import { Form, message } from 'antd';
import { useDispatch } from 'dva';
import { useState, useCallback } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
// import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import InputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import AddSelectML from '@/components/select_ml/add_select_ml/AddSelectML';
import { CONSTANT } from '../../../constant/index';
import Loading from '@/components/Loading';
import { isNumber } from '@/utils/validation';
import styles from './addMember.less?modules';

const AddMember = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // 发起请求
  const onFinish = (values) => {
    setLoading(true);
    dispatch({
      type: 'ruleginMM/addMember',
      payload: {
        values: {
          ...values,
        },
      },
      callback: (data) => {
        setLoading(false);
        if (data.id) {
          message.success('新增成功');
          props.handleOk(data);
        } else {
          message.error(data.message);
        }
      },
    });
  };

  const handleCancel = () => {
    props.handleCancel();
  };

  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 模型编号 */}
          <InputML
            labelVal="模型编号"
            placeVal="请输入模型编号"
            name="modelNo"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入模型编号',
              },
              () => ({
                validator(rule, value) {
                  if (!value || isNumber(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject('模型编号格式为数字');
                },
              }),
            ]}
          />

          {/* 模型名称 */}
          <InputML
            labelVal="模型名称"
            placeVal="请输入模型名称"
            name="modelName"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入模型名称',
              },
            ]}
          />

          {/* 输出 */}
          <InputML
            labelVal="输出"
            placeVal="请输入输出"
            name="outputIndex"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请填写输出',
              },
            ]}
          />

          {/* 模型状态 */}
          <AddSelectML
            required={[
              {
                required: true,
                message: '请选择模型状态',
              },
            ]}
            height="47px"
            labelwidth="130px"
            labelVal="模型状态"
            placeVal="请选择模型状态"
            name="modelStatus"
            option={CONSTANT.statusList}
          />
          {/* 描述 */}
          <InputML
            labelVal="模型描述"
            placeVal="请输入模型描述"
            name="description"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请填写模型描述',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default AddMember;
